export default __webpack_public_path__ + "static/media/checkmark_active.cb30f55f.PNG";